import { render, staticRenderFns } from "./PostReg.vue?vue&type=template&id=6242c3b5&scoped=true"
import script from "./PostReg.vue?vue&type=script&lang=js"
export * from "./PostReg.vue?vue&type=script&lang=js"
import style0 from "./PostReg.vue?vue&type=style&index=0&id=6242c3b5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242c3b5",
  null
  
)

export default component.exports